// extracted by mini-css-extract-plugin
export var label = "_5t-1";
export var reminder = "_5t-0";